<script setup lang="ts">
import type { IFeatureItem } from '../../../models'
import FeatureListItem from './FeatureListItem.component.vue'

const items: IFeatureItem[] = (useAttrs().items || ([] as any)).filter((x: IFeatureItem) => !x.exclude)

// ensure minMaxCol is at least 1 and at most 3
const minMaxCol = Math.max(1, Math.min(items.length, 3))
const cssClass = `grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-${minMaxCol}`

const emits = defineEmits<{
  (e: 'viewLargeImage', item: IFeatureItem): void
}>()

const viewLargeImage = (item: IFeatureItem) => {
  emits('viewLargeImage', item)
}
</script>

<template>
  <div :class="cssClass">
    <FeatureListItem v-for="item of items" :key="item.key" :model="item">
      <template v-if="(item.imageSrc || '').length > 0" #default>
        <div class="w-full flex justify-center cursor-pointer" @click="() => viewLargeImage(item)">
          <picture>
            <source :srcset="item.imageSrc?.replace('.png', '.webp')" type="image/webp" />
            <source :srcset="item.imageSrc" type="image/png" />
            <img
              :src="item.imageSrc?.replace('.png', '.webp')"
              :alt="item.header"
              class="max-w-[16rem] max-h-[16rem] rounded-md shadow-xl border border-primary"
            />
          </picture>
        </div>
      </template>
    </FeatureListItem>
  </div>
</template>
